import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const AUTH_SESSION: UrlConstant = { path: '/sessions/auth', method: HttpMethod.POST };
export const STOP_SESSION: UrlConstant = { path: '/sessions/stop', method: HttpMethod.POST };
export const PAUSE_SESSION: UrlConstant = { path: '/sessions/pause', method: HttpMethod.POST };
export const TIMEOUT_SESSION: UrlConstant = { path: '/sessions/timeout', method: HttpMethod.POST };
export const START_SESSION: UrlConstant = { path: '/sessions/initialize', method: HttpMethod.POST };
